import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type SynergiesQueryVariables = {
  department?: Types.Maybe<Types.Scalars['String']>,
  vehicleType?: Types.Maybe<Types.Scalars['String']>,
  vehicleModel?: Types.Maybe<Types.Scalars['String']>,
  vehicleDerivative?: Types.Maybe<Types.Scalars['String']>,
  internalLabel?: Types.Maybe<Types.Scalars['String']>,
  licensePlate?: Types.Maybe<Types.Scalars['String']>,
  modelYear?: Types.Maybe<Types.Scalars['String']>,
  provingGround?: Types.Maybe<Types.Scalars['String']>,
  resource?: Types.Maybe<Types.Scalars['String']>,
  dateFrom?: Types.Maybe<Types.Scalars['Date']>,
  dateTo?: Types.Maybe<Types.Scalars['Date']>
};


export type SynergiesQuery = (
  { __typename?: 'Query' }
  & { synergies: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id' | 'title' | 'dateFrom' | 'dateTo' | 'department' | 'relevance' | 'matches'>
    & { provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
    )>, responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )> }
  )> }
);

export const SynergiesDocument = gql`
    query Synergies($department: String, $vehicleType: String, $vehicleModel: String, $vehicleDerivative: String, $internalLabel: String, $licensePlate: String, $modelYear: String, $provingGround: String, $resource: String, $dateFrom: Date, $dateTo: Date) {
  synergies(department: $department, vehicleType: $vehicleType, vehicleModel: $vehicleModel, vehicleDerivative: $vehicleDerivative, internalLabel: $internalLabel, licensePlate: $licensePlate, modelYear: $modelYear, provingGround: $provingGround, resource: $resource, dateFrom: $dateFrom, dateTo: $dateTo) {
    _id
    id
    title
    dateFrom
    dateTo
    department
    relevance
    matches
    provingGround {
      _id
      title
      countryCode
    }
    responsible {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
  }
}
    `;

    export function useSynergiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SynergiesQuery, SynergiesQueryVariables>) {
      return ApolloReactHooks.useQuery<SynergiesQuery, SynergiesQueryVariables>(SynergiesDocument, baseOptions);
    };
      export function useSynergiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SynergiesQuery, SynergiesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<SynergiesQuery, SynergiesQueryVariables>(SynergiesDocument, baseOptions);
      };
      
export type SynergiesQueryHookResult = ReturnType<typeof useSynergiesQuery>;
export type SynergiesQueryResult = ApolloReactCommon.QueryResult<SynergiesQuery, SynergiesQueryVariables>;